export default __webpack_public_path__ + "static/media/app_store_badge_564x168.a7cef383.png";